import { createMultipleParam } from '@appscience/utils'
import { indexBy, prop } from 'ramda'
import { API_URL } from 'src/config/environment'
import { ArchiveItem } from '../../../views/warehouse/from-warehouse/archive/model/atoms'
import apiCreator from '../../api-creator'
import { Api_Item } from '../../common/item-model'
import {
  getItemInvoicePrice,
  handleErrorWithDefaultValue,
} from '../../common/utils'
import { parseDate } from '@app/utils/date'

interface Params {
  warehouseIds: Array<string>
  packageId?: string
}

export function getArchiveItems({
  warehouseIds,
  packageId,
}: Params): Promise<Record<string, ArchiveItem>> {
  if (packageId !== undefined) {
    return apiCreator
      .get(`${API_URL.TWIN}/get-package?id=${packageId}`)
      .then(res => {
        const rawData: Array<Api_Item> = res.data.items
        return indexBy(prop('id'), rawData.map(remapToArchiveItem))
      })
      .catch(handleErrorWithDefaultValue({}))
  }
  return apiCreator
    .get(
      `${API_URL.TWIN}/items?step=in-package&${createMultipleParam(
        warehouseIds,
        'from_warehouse_id',
      )}&shipment_status=archive`,
    )
    .then(res => {
      const rawData: Array<Api_Item> = res.data.items
      return indexBy(prop('id'), rawData.map(remapToArchiveItem))
    })
    .catch(handleErrorWithDefaultValue({}))
}

export function remapToArchiveItem(data: Api_Item): ArchiveItem {
  return {
    id: data.id,
    airtableLink: data.airtable_link,
    expiredDate: parseDate(data.provider_exp),
    amoId: data.deal_id,
    procurement: data.procurement,
    toHub0: parseDate(data.sent_to_hub_0 || '') || null,
    hub0: data.hub_0,
    trackHub0: data.track_to_hub_0,
    tswed: parseDate(data.registration_date || '') || null,
    responsibleSCD: data.responsible_scd,
    invoicePrice: getItemInvoicePrice(data) || 0,
    currencyId: data.currency,
    originCountry: data.country_of_origin,
    lot: data.provider_lot,
    source_number: data.source_number,
    transporterId: data.transporter,
    hsCodeSecondary: data.hs_code_secondary,
    departureDate: parseDate(data.departure_date),
    toWarehouseId: data.to_warehouse_id,
    brand: data.brand,
    store: data.store,
    grossWeight: data.gross_weight_kg,
    netWeight: data.net_weight_kg,
    invoiceName: data.name,
    itemCost: data.cost,
    tax: data.tax,
    otherCost: data.other_cost,
    sumCost: data.full_cost,
    customPrice: data.custom_price_main,
    customPriceCurrency: data.custom_price_currency,
    locations: data.provider_locations,
    prtComments: data.procurement_comment,
    originalName: data.original_name,
    catalogueId: data.catalogue_id,
    temperatureId: data.provider_temp,
    hazmat: data.provider_hazmat,
    invoiceNumber: data.package_invoice,
    quantity: data.quantity,
    packing: data.package_size,
    exportStatuses: data.provider_export_statuses || [],
    exportComment: data.provider_comment,
    boxNumber: data.box_numbers,
    express: data.express ?? false,
    providerTagToHub: data.provider_tag_to_hub,
    providerTagToTransit: data.provider_tag_to_transit,
    providerTagToRu: data.provider_tag_to_ru,
    sdExp: String(data.sd_exp || '').trim(),
  }
}
